export abstract class ReferencesEvent {}

export class ReferencesLoad extends ReferencesEvent {}
